import type { WindowProps } from './interface';

import { DEFAULT_CDN_CSS } from '../constants';

export const openWindow = ({ body, links = [], title }: WindowProps) =>
  new Promise<void>(resolve => {
    const styleLinks = [DEFAULT_CDN_CSS, ...links].reduce(
      (acc, link) => `${acc}<link type="text/css" rel="stylesheet" href="${link}">`,
      '',
    );

    const page: any = window.open();
    const content = `
    <head>
        <title>${title}</title>
        ${styleLinks}
    </head>
    <body>${body}</body>
  `;

    page.document.write(content);

    page.document.close();
    resolve();
  });
